// Material Kit 2 React pages
import OurServices from "pages/Services/OurServices";

export default function OurServicesPage() {
  return <OurServices />;
}
